import { connect } from 'react-redux';

const Alert = ({ alerts }) => {
    if (!alerts || alerts.length === 0) return null;

    return (
        <div className="alert-container" style={{ position: 'fixed', top: '1rem', right: '1rem', zIndex: 9999, minWidth: '280px' }}>
            {alerts.map(alert => (
                <div
                    key={alert.id}
                    style={{
                        background: alert.alertType === 'success' ? '#1a2e1a' : alert.alertType === 'danger' ? '#2e1a1a' : '#1F1F1F',
                        border: `1px solid ${alert.alertType === 'success' ? '#F5C800' : alert.alertType === 'danger' ? '#E53E3E' : '#2E2E2E'}`,
                        color: alert.alertType === 'success' ? '#F5C800' : alert.alertType === 'danger' ? '#E53E3E' : '#F0F0F0',
                        borderRadius: '10px',
                        padding: '0.85rem 1.1rem',
                        marginBottom: '0.5rem',
                        fontWeight: 500,
                        fontSize: '0.95rem',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
                    }}
                >
                    <i className={`fas fa-${alert.alertType === 'success' ? 'check-circle' : 'exclamation-circle'} me-2`}></i>
                    {alert.msg}
                </div>
            ))}
        </div>
    );
};

const mapStateToProps = state => ({
    alerts: state.alert
});

export default connect(mapStateToProps)(Alert);
